import * as myxhr from "./myxhr.js";

export function post(body) {
    return myxhr.post('/login', body);
}